var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"link-bubble-menu"},[_vm._t("prepend"),_c('menu-open-link-button',{attrs:{"editor":_vm.editor}}),_c('menu-edit-link-button',{attrs:{"editor":_vm.editor}}),_c('menu-remove-link-button',{attrs:{"editor":_vm.editor}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }